import LateswapCsvLineupInterface from './lateswap-csv-lineup-interface';
import LateswapCsvPlayerInterface from '../player-view/lateswap-csv-player-interface';

class LateswapCsvLineup implements LateswapCsvLineupInterface {
    constructor(
        private lineupId: string,
        private entryId: string,
        private details: any[],
        private players: LateswapCsvPlayerInterface[],
    ) {}

    getLineupId(): string {
        return this.lineupId;
    }

    getEntryId(): string {
        return this.entryId;
    }

    getDetails(): any[] {
        return [...this.details];
    }

    getPlayers(): LateswapCsvPlayerInterface[] {
        return this.players;
    }
}

export default LateswapCsvLineup;
